import React, { SVGProps } from 'react';

export default function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="icon_facebook"
      height="1.5em"
      viewBox="0 0 24 24"
      width="1.5em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={12} cy={12} fill="#3b5998" r={12} />
      <path
        d="M13.079 19h-2.9v-7H8.738V9.592h1.442V8.136c0-1.96.813-3.136 3.136-3.136h1.933v2.408h-1.2c-.91 0-.965.35-.965.966v1.218h2.183L15.01 12h-1.931z"
        fill="#fff"
      />
    </svg>
  );
}
